/**
 * Which wallet the device can pay with: Apple devices -> Apple Pay, Android -> Google Pay, anything else
 * (desktop / unknown) -> both. Telegram's platform is used when available, else the browser's user agent.
 */
export type WalletDevice = 'apple' | 'android' | 'unknown';

export function walletDevice(): WalletDevice {
  const tgPlatform = (window as unknown as { Telegram?: { WebApp?: { platform?: string } } }).Telegram?.WebApp?.platform ?? '';
  if (tgPlatform === 'ios') return 'apple';
  if (tgPlatform === 'android' || tgPlatform === 'android_x') return 'android';
  const ua = navigator.userAgent;
  if (/Android/i.test(ua)) return 'android';
  if (/iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) return 'apple';
  return 'unknown';
}

/** false = hide this wallet option on this device */
export function walletAllowed(wallet: 'apple' | 'google'): boolean {
  const d = walletDevice();
  return d === 'unknown' || (wallet === 'apple' ? d === 'apple' : d === 'android');
}
